<div class="container">
  <ngx-file-drop
    (onFileDrop)="dropped($event)"
    [multiple]="true"
    class="converter-box"
    contentClassName="converter"
    dropZoneClassName="file-drop"
  >
    <ng-template
      let-openFileSelector="openFileSelector"
      ngx-file-drop-content-tmp
    >
      @if (!isCompact) {
        <img
          alt="Logo"
          class="logo"
          src="assets/images/upload-illustration.svg"
        />
      }

      <p class="drag-n-drop">{{ "home.fileBox.dragDrop" | translate }}</p>
      <p class="subtitle">{{ "home.fileBox.or" | translate }}</p>
      <button
        (click)="openFileSelector()"
        class="upload-btn"
        type="button"
      ></button>
      <p class="drag-n-drop">{{ "home.fileBox.clickBrowse" | translate }}</p>
      <p class="subtitle note">{{ "home.fileBox.uploadLimit" | translate }}</p>

      @if (monthlyConvertedFiles$ | async; as monthlyConvertedFiles) {
        <p
          class="monthly-files"
          [innerHTML]="
            'home.fileBox.monthlyConvertedFiles'
              | translate: { count: monthlyConvertedFiles.count }
          "
        ></p>
      }
    </ng-template>
  </ngx-file-drop>
</div>
@if (showQueueLimitModal) {
  <app-confirmation-modal
    class="confirmation-modal"
    [title]="'home.confirmModal.uploadLimitTitle' | translate"
    [message]="
      'home.confirmModal.uploadLimitError'
        | translate: { count: MAX_FILE_COUNT }
    "
    [isSingleAction]="true"
    (close)="onQueueLimitModalClosed()"
  />
}
@if (showQueueLimitModalWithSlots) {
  <app-confirmation-modal
    class="confirmation-modal"
    [title]="'home.confirmModal.uploadLimitTitle' | translate"
    [message]="
      'home.confirmModal.maxUploadReached'
        | translate: { count: availableSlots }
    "
    [isSingleAction]="true"
    (close)="onQueueLimitModalWithSlotsClosed()"
  />
}
